
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        editMode: {
            type: Boolean,
            default: false
        }
    },
    inject: {
        registerPin: {
            default: () => () => null
        }
    },
    data() {
        return {
            show: true,
            active: false,
            rotation: 0
        };
    },
    mounted() {
        if (this.editMode) return;
        this.registerPin(this);
        const r = Math.floor(Math.random() * 7) - 3;
        this.rotation = r === 0 ? 1 : r;
    }
});
